import { AttributeCollection, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode"
import { SiteData } from "../Data/SiteData";
import { AttributeDefinition, AttributeInputType, AttributeTargetType } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import ImageField from "../StyleInputs/ImageField";




export default function ImageMappingMenu({saveFunc,siteData}:{saveFunc:Function,siteData:SiteData}){

  
    
    const mapAtt = new AttributeDefinition("imageMapping","Image Mapping","",AttributeInputType.ImageField,[],{min:0,max:5,step:1,unit:""},AttributeTargetType.Component);
    for(let i = 0;i<siteData.siteStyling.imageMapping.length;i++){

        let url = siteData.siteStyling.imageMapping[i];
        if(url.length<5)
            continue;
        //update all mappings to the new list
        if(!siteData.imageUrls.includes(siteData.siteStyling.imageMapping[i])){
            siteData.imageUrls.push(siteData.siteStyling.imageMapping[i]);
        }
    }

    let  newImageList = siteData.siteStyling.imageMapping.join(",");


    const updateAtt = (  attribute: string, value: string, targetType: AttributeTargetType) =>{
          
       

       
        siteData.siteStyling.imageMapping = value.split(",");
        siteData.userContext.imageMapping = siteData.siteStyling.imageMapping;
        
        siteData.onUpdateStyle();
        siteData.isStyleSaveDirty = true;
        siteData.isStylePublishDirty = true;
       
        saveFunc();

    }

    const attCollection = new AttributeCollection();
    setNodeComponentAttributeValue(attCollection,"imageMapping",newImageList);


    return(
           <>
              <h2 className="panel-heading">Image Mapping</h2>
           
                <ImageField label="Select 5 Images" definition={mapAtt} layoutObject={attCollection} updateFunc={updateAtt} saveFunc={saveFunc} screenSize={ScreenSize.Desktop} siteData={siteData}/>
             
            </>
)





}